export const TOTAL_RATINGS = 4;
export const RATING_TITLES = ['Poor', 'Okay', 'Good', 'Excellent'];